import { PropsWithChildren, useEffect } from 'react';
import { MonkThemeProvider, useMonkAppState, useMonkTheme } from '@monkvision/common';
import { getAuthTokenRegion } from '../auth';
import { useAppRegion } from '../contexts';

function RootStylesContainer({ children }: PropsWithChildren<unknown>) {
  const { rootStyles, palette } = useMonkTheme();

  return (
    <div className='app-container' style={{ ...rootStyles, color: palette.text.primary }}>
      {children}
    </div>
  );
}

export function AppContainer({ children }: PropsWithChildren<unknown>) {
  const { setRegion } = useAppRegion();
  const { authToken, config } = useMonkAppState();

  useEffect(() => {
    const region = getAuthTokenRegion(authToken);
    if (region) {
      setRegion(region);
    }
  }, [authToken]);

  return (
    <MonkThemeProvider palette={config.palette}>
      <RootStylesContainer>{children}</RootStylesContainer>
    </MonkThemeProvider>
  );
}
